import { Box, Grid, Stack } from "@mui/material";
import { SSText } from "src/components/base/components/SSText";
import {
  PassCard,
  TPassCardProps,
} from "src/components/feature/PurchaseFlow/PassCard";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { TPass } from "src/shared/types/globalStotre.types";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";

export function PassCardList(props: {
  title?: string;
  passes: TPass[];
  passCardProps?: Partial<TPassCardProps>;
}) {
  const theme = useSSTheme();
  const { md: mdUp } = useCssMediaQuery("up");
  const { LANGUAGES, TEAM_GLOBAL_SETTINGS } = useTeamConfig();

  if (!props?.passes.length) return null;

  return (
    <Stack width={"100%"} spacing={2}>
      {props?.title ? (
        <Box textAlign={mdUp ? "center" : "left"}>
          <SSText variant="h6" fontWeight={700} color={theme.colors.gray[200]}>
            {props.title}
          </SSText>
        </Box>
      ) : null}

      <Box>
        <Grid
          container
          spacing={3}
          justifyContent={mdUp ? "center" : "flex-start"}
        >
          {props.passes.map((pass, idx) => {
            return (
              <Grid
                item
                key={pass.passId}
                xs={12}
                sm={props.passes.length <= 1 ? 12 : 6}
                lg={props?.passes?.length <= 1 ? 12 : 4}
              >
                <PassCard
                  pass={pass}
                  showFAQButton={Boolean(
                    LANGUAGES?.PRE_PURCHASE_FAQS_BY_PASS_ID?.[pass.passId]
                      ?.length
                  )}
                  hideSubscribeButton={
                    Boolean(pass?.isGiftEligible) &&
                    TEAM_GLOBAL_SETTINGS?.DISABLE_STANDARD_PURCHASE_ON_GIFT_PASSES
                  }
                  {...props.passCardProps}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Stack>
  );
}
